// src/geograph/about/releases.js

/**
 * 更新履歴（Aboutと、更新通知の“ソース”として共通利用する）
 *
 * ルール（おすすめ）:
 * - 配列の先頭が最新（Latest扱い）
 * - id は必須（localStorageの比較キーにも使える）
 * - dateLabel は表示用（自由記述OK）
 * - dateISO は並び替え/比較用（任意だがあると強い）
 */

export const ABOUT_RELEASES = [
  {
    id: "v4.0_2026-03-16",
    version: "4.0",
    dateISO: "2026-03-16",
    dateLabel: "Mar 16th, 2026",
    title: "ジオグラフv4.0を公開しました",
    bullets: [
      "「国土全体を見る」モードで、地域選択ボタンから七地方区分での表示が行えるようになりました。",
      "2021年の経済センサスを反映しました。",
      "土地の使われ方や植生の様子に関わるテーマを更新しました（協力：JAXA）。",
      "テーマ07ｰ02「ソーラーパネルが見られるところ」では、経年変化が可視化されました。",
      "テーマ14ｰ03「岩礁・干潟が見られるところ」が搭載されました。",
      "使い方ページに、実践事例を追加しました。",
      "ご要望などございましたら、学校の先生を通じて、お気軽に帝国書院の営業担当までお知らせください。",
    ],
    links: [],
  },

  {
    id: "v3.6_2025-03-27",
    version: "3.6",
    dateISO: "2025-03-27",
    dateLabel: "Mar 27th, 2025",
    title: "ジオグラフv3.6を公開しました",
    bullets: [
      "事例&解説を相当数のテーマで追加しました。",
      "使い方ページに3種の実践事例を追加しました。",
    ],
    links: [],
  },

  {
    id: "v3.5_2024-12-13",
    version: "3.5",
    dateISO: "2024-12-13",
    dateLabel: "Dec 13th, 2024",
    title: "ジオグラフv3.5を公開しました",
    bullets: ["一部の画像を差し替えました。"],
    links: [],
  },

  {
    id: "v3.4_2024-03-27",
    version: "3.4",
    dateISO: "2024-03-27",
    dateLabel: "Mar 27th, 2024",
    title: "ジオグラフv3.4を公開しました",
    bullets: [
      "土地の使われ方や植生の様子に関わるテーマを大幅に増やしました（協力：JAXA）。テーマ選択＞出典＞JAXA から一覧できます。",
      "ほか、使い方ページに、実践事例を追加しました。",
    ],
    links: [],
  },

  {
    id: "v3.3_2023-10-27",
    version: "3.3",
    dateISO: "2023-10-27",
    dateLabel: "Oct 27th, 2023",
    title: "ジオグラフv3.3を公開しました",
    bullets: ["使い方ページに、活用事例を追加しました。"],
    links: [],
  },

  {
    id: "v3.2_2023-08-27",
    version: "3.2",
    dateISO: "2023-08-27",
    dateLabel: "Aug 27th, 2023",
    title: "ジオグラフv3.2を公開しました",
    bullets: [
      "交通・工業・観光業に関わるテーマを増やしました（08-07,08-08,09-07,09-08）",
      "2020年の国勢調査を、一部のテーマを除いて反映しました。",
      "＊2015年の国勢調査データが見られる以前のバージョンはこちら",
    ],
    links: [
      {
        href: "https://gg31.teikokushoin.co.jp",
        label: "ジオグラフ（バージョン3.１）",
        icon: "download",
      },
    ],
  },

  {
    id: "v3.1_2023-04-27",
    version: "3.1",
    dateISO: "2023-04-27",
    dateLabel: "Apr 27th, 2023",
    title: "ジオグラフv3.1を公開しました",
    bullets: ["事例とその解説モードでの表示を改善しました。"],
    links: [],
  },

  {
    id: "v3.0_2023-03-27",
    version: "3.0",
    dateISO: "2023-03-27",
    dateLabel: "Mar 27th, 2023",
    title: "ジオグラフv3.0を公開しました",
    bullets: [
      "基幹部分を刷新しました。",
      "ズーム、初期視点に戻る、の操作を、ダブルクリックからシングルクリックに変更しました。",
      "ズームした際の凡例の動作を改善しました。",
      "事例とその解説のページについてもブックマークができるようになりました。",
    ],
    links: [],
  },

  {
    id: "v2.7_2022-11-22",
    version: "2.7",
    dateISO: "2022-11-22",
    dateLabel: "Nov 22nd, 2022",
    title: "ジオグラフv2.7を公開しました",
    bullets: [
      "日本測地系に対応しました。",
      "昔と比較するタブの表示年次を調整しました。",
      "チュートリアル、FAQの微調整を行いました。",
      "いくつかのテーマで事例&解説を追加しました。",
    ],
    links: [],
  },

  {
    id: "v2.6_2022-10-20",
    version: "2.6",
    dateISO: "2022-10-20",
    dateLabel: "Oct 20th, 2022",
    title: "ジオグラフv2.6を公開しました",
    bullets: ["使い方ページのキャラクターを変更しました。", "誤植を修正しました。"],
    links: [],
  },

  {
    id: "v2.5_2022-08-26",
    version: "2.5",
    dateISO: "2022-08-26",
    dateLabel: "Aug 26th, 2022",
    title: "ジオグラフv2.5を公開しました",
    bullets: [
      "使い方ページをリニューアルしました。",
      "ご要望を踏まえ、アイコンを一部変更しました。",
      "小中学校用のテーマが増えました。",
    ],
    links: [],
  },

  {
    id: "v2.4_2022-08-01",
    version: "2.4",
    dateISO: "2022-08-01",
    dateLabel: "Aug 1st, 2022",
    title: "ジオグラフv2.4を公開しました",
    bullets: [
      "市町村別のKMLがダウンロードできます。凡例の「詳細を見る」をご確認ください。なお、一部データは準備中です。",
      "一部テーマで「設定」ボタンの表示を修正しました。",
    ],
    links: [],
  },

  {
    id: "v2.3_2022-05-23",
    version: "2.3",
    dateISO: "2022-05-23",
    dateLabel: "May 23rd, 2022",
    title: "ジオグラフv2.3を公開しました",
    bullets: ["テーマ選択画面を改善しました。URLが一部変更されました。"],
    links: [],
  },

  {
    id: "v2.2_2022-04-05",
    version: "2.2",
    dateISO: "2022-04-05",
    dateLabel: "April 5th, 2022",
    title: "ジオグラフv2.2を公開しました",
    bullets: ["トップページのデザインを変更しました。"],
    links: [],
  },

  {
    id: "v2.1_2022-04-01",
    version: "2.1",
    dateISO: "2022-04-01",
    dateLabel: "April 1st, 2022",
    title: "ジオグラフv2.1を公開しました",
    bullets: [
      "右上に、使い方ページへのリンクを追加しました。どの画面からも使い方ページに移動できます。",
      "搭載データを増やしました。",
    ],
    links: [],
  },

  {
    id: "v2_2022-03-13",
    version: "2",
    dateISO: "2022-03-13",
    dateLabel: "March 13th, 2022",
    title: "ジオグラフv2を公開しました",
    bullets: [
      "いただいたご要望に沿って機能を改善するとともに、学校で使われる標準的な画面サイズに最適化しました。タブレットから操作しやすいように、画面のデザインの改善を行いました。",
      "搭載データを増やしました。",
    ],
    links: [],
  },

  {
    id: "release_2021-05-21",
    version: "1",
    dateISO: "2021-05-21",
    dateLabel: "May 21st, 2021",
    title: "ジオグラフを公開しました",
    bullets: ["ジオグラフを公開しました。"],
    links: [
      {
        href: "https://www.teikokushoin.co.jp/hs2021/assets/docs/gis/catalog.pdf",
        label: "【先生向け】はじめてのGISサポート（pdfファイル）",
        icon: "download",
      },
    ],
  },

  {
    id: "trial_2021-04-09",
    version: "0",
    dateISO: "2021-04-09",
    dateLabel: "April 9th, 2021",
    title: "ジオグラフを試験公開しました",
    bullets: ["ジオグラフを試験公開しました。"],
    links: [],
  },
];

/** 先頭＝最新、という運用の補助 */
export const getLatestRelease = () => ABOUT_RELEASES[0];

/** 更新通知側が使う “最新ID” */
export const getLatestReleaseId = () => String(getLatestRelease()?.id || "");
